goog.provide("shadow.js.shim.module$src$svg$objects$movie_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$movie_svg");
shadow.js.shim.module$src$svg$objects$movie_svg = shadow.js.nativeProvides["src/svg/objects/movie.svg"] = shadow$bridge("src/svg/objects/movie.svg");
module$shadow_js_shim_module$src$svg$objects$movie_svg.default = shadow.js.shim.module$src$svg$objects$movie_svg;
